import { EntityPluginMarketplaceContent } from '@devxdiscover/plugin-marketplace';

/**
 * A new marketplace component that renders the EntityPluginMarketplaceContent.
 */
const NewMarketplace = () => {
  return (
    <>
      <EntityPluginMarketplaceContent />
    </>
  );
};

export default NewMarketplace;
